import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../Contexts/AuthContext";

export type ApiVersionInfo = {
  version: string;
  commit: string;
  branch: string;
  buildDate: string;
};

const useApiVersion = (enabled: boolean) => {
  const Auth = useAuth();

  return useQuery<ApiVersionInfo, Error>({
    queryKey: ["version"],
    queryFn: ({ signal }) =>
      Auth.AuthenticatedServerCall<ApiVersionInfo>(
        `${import.meta.env.VITE_APIURL}version`,
        "GET",
        undefined,
        { signal },
      ),
    enabled,
    retry: false,
    staleTime: Infinity,
  });
};

export default useApiVersion;
